import PropTypes from "prop-types";
import React from "react";

const Avartar = ({ src }) => {
  const styleAvartar = {
    height: "150px",
    width: "150px",
    backgroundImage: `url(${src})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    margin: "auto",
    borderRadius: "50%",
  };
  return <div style={styleAvartar}></div>;
};

Avartar.propTypes = {
  src: PropTypes.string,
  size: PropTypes.string,
  onClick: PropTypes.func,
};

export default Avartar;
